(self["webpackChunk"] = self["webpackChunk"] || []).push([[6325],{

/***/ 86325:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";

// EXTERNAL MODULE: ./components/select/index.scss
var components_select = __webpack_require__(41911);
// EXTERNAL MODULE: ./utils/prevent_parent_scroll/index.js
var prevent_parent_scroll = __webpack_require__(61258);
// EXTERNAL MODULE: ./utils/media_query/index.js
var media_query = __webpack_require__(28925);
;// CONCATENATED MODULE: ./components/select/lib/cache.js
/* harmony default export */ const cache = ({
    configureCache () {
        if (this.ajax && this.ajaxUrl) {
            this.cacheKey = `select_cache_${this.ajaxUrl.toLowerCase()}`;
        } else if (this.thor && this.thorModel) {
            this.cacheKey = `select_cache_${this.name}_${this.thorModel.toLowerCase()}`;
        } else {
            this.cacheKey = `select_cache_${this.name}`;
        }
    },
    setCache (data) {
        if (RAILS_ENV === 'development' || !this.enableCache || !data || !data.length) return;
        try {
            sessionStorage.setItem(this.cacheKey, JSON.stringify(data));
        } catch (ex) {
            Rollbar.info('qselect: Cache lotado!', ex);
        }
    },
    getCache () {
        if (RAILS_ENV === 'development' || !this.enableCache) return;
        try {
            return JSON.parse(sessionStorage.getItem(this.cacheKey));
        } catch (ex) {
            this.clearCache();
            Rollbar.info(`qselect: Um cache inválido foi apagado. Key: ${this.cacheKey}`);
        }
    },
    clearCache () {
        sessionStorage.removeItem(this.cacheKey);
        this._execCallbacks('clearCache');
    }
});

;// CONCATENATED MODULE: ./components/select/lib/externals.js
/* harmony default export */ const externals = ({
    _execCallbacks (event) {
        const callbacks = this.callbacks ? this.callbacks[event] : null;
        const args = window.jQuery.makeArray(arguments);
        args.shift();
        args.push(this.$component); // Always put jQuery element as last param
        this._execJQueryCallbacks(event, args);
        if (callbacks && callbacks.length > 0) {
            for(let i = 0; i < callbacks.length; i++){
                callbacks[i](...args);
            }
        }
    },
    _execJQueryCallbacks (event, params) {
        this.$component.trigger(event, ...params);
    },
    on (event, callback) {
        this.callbacks = this.callbacks || {};
        this.callbacks[event] = this.callbacks[event] || [];
        if (typeof callback === 'function') {
            this.callbacks[event].push(callback);
        }
    },
    close () {
        this.$component.removeClass('open');
        window.jQuery('.dropdown-menu', this.$component).trigger('hide.bs.dropdown');
        this._execCallbacks('close');
    },
    refresh (trigger = true) {
        const data = this._getPage(this.currentPage).data;
        this.renderOptions(data, true, trigger);
        this._execCallbacks('refresh');
    },
    enable () {
        this.$component.data('disabled', false);
        this.loadConfig();
        window.jQuery('.dropdown-toggle', this.$component).removeAttr('disabled');
        this._execCallbacks('enable');
    },
    disable () {
        this.$component.data('disabled', true);
        this.loadConfig();
        window.jQuery('.dropdown-toggle', this.$component).attr('disabled', true);
        this._execCallbacks('disable');
    },
    reset (clear = true) {
        this.currentPage = 1;
        this.filteredOptions = [];
        this.renderedValues = [];
        this.config.value = '';
        if (clear) {
            this.selectedValues = [];
            window.jQuery('input[type="checkbox"], input[type="radio"]', this.$component).prop('checked', false).trigger('change');
        } else {
            if (this.selectedValues) {
                this.selectedValues = this.filterValues(this.selectedValues);
            } else {
                this.selectedValues = [];
            }
        }
        this.renderOptions(this._getPage(1).data, true, false);
        // Ajax
        if (!this.ajax) {
            return;
        }
        this.isDataFetched = false;
        this.$ajaxData = window.jQuery('.js-ajax-data', this.$component);
    },
    setValue (value) {
        if (this.ajax) {
            const val = (Array.isArray(value) ? value : [
                value
            ]).map((x)=>x.toString());
            if (this.isDataFetched) {
                this.selectedValues = this.filterValues(val);
                this.refresh(false);
                this._execCallbacks('change', this.selectedValues);
            } else {
                this.fetch(null, val);
            }
        } else {
            const $input = window.jQuery(`input[type="checkbox"][value="${value}"], input[type="radio"][value="${value}"]`, this.$component);
            if (!$input.length) {
                return;
            }
            $input.prop('checked', true);
            setTimeout(()=>{
                if (this.multiple) {
                    this.updateCounter();
                } else {
                    this.updateSelected();
                }
            }, 1);
        }
    },
    getValue (cb = null) {
        const value = this.multiple ? this.selectedValues.length ? this.selectedValues : [
            this.config.value
        ] : this.config.value;
        if (cb && typeof cb === 'function') {
            cb(value);
        } else {
            return value;
        }
    },
    setConfig (config) {
        const component = this.$component.get(0);
        window.jQuery(Object.keys(config)).each((i, key)=>{
            component.dataset[key] = config[key];
        });
        this.$component.data(config);
        this.loadConfig();
    },
    getConfig (cb) {
        if (cb && typeof cb === 'function') {
            cb(this.config);
        } else {
            return this.config;
        }
    },
    setFormatFunction (func) {
        this.formatFunction = func;
    },
    setOptionRenderingFunction (func) {
        this.optionRenderingFunction = func;
    }
});

;// CONCATENATED MODULE: ./components/select/lib/data_sources/ajax.js
/* harmony default export */ const ajax = ({
    configureAjax () {
        if (!this.ajax) return;
        this.perPage = this.config.perPage;
        this.textField = this.config.textField;
        this.valueField = this.config.valueField;
        this.collectionRoot = this.config.ajaxCollectionRoot;
    },
    fetchAjax (params) {
        const deferred = window.jQuery.Deferred();
        window.jQuery.ajax({
            url: this.ajaxUrl,
            method: 'GET',
            dataType: 'json',
            data: params,
            success: (data)=>{
                deferred.resolve(data);
            },
            error: (xhr, textStatus, err)=>{
                deferred.reject({
                    xhr,
                    textStatus,
                    err
                });
            }
        });
        return deferred.promise();
    }
});

;// CONCATENATED MODULE: ./components/select/lib/data_sources/thor.js
/* harmony default export */ const thor = ({
    configureThor () {
        if (this.thor) {
            this.ajax = true;
            this.thorModel = this.config.thorModel;
            this.Model = Thor[this.thorModel];
        }
    },
    fetchThor (params) {
        const deferred = window.jQuery.Deferred();
        this.Model.get(params).then((data)=>{
            deferred.resolve(data);
        }).catch((err)=>deferred.reject(err));
        return deferred.promise();
    }
});

;// CONCATENATED MODULE: ./components/select/lib/fetch.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}


let Fetch = {
    attempts: 1,
    configureFetch () {
        this.configureThor();
        this.configureAjax();
    },
    fetchCached (selectWhenFetch) {
        let cached = this.getCache();
        if (cached) {
            this.setOptions(cached, selectWhenFetch);
            return true;
        }
        if (this.$ajaxData && this.$ajaxData.length) {
            this.ajaxData = JSON.parse(this.$ajaxData.html());
            this.setCache(this.ajaxData);
            this.setOptions(this.ajaxData, selectWhenFetch);
            this.$ajaxData.html('');
            return true;
        }
        return false;
    },
    setOptions (data, selectWhenFetch = null, render = true) {
        if (selectWhenFetch) selectWhenFetch = selectWhenFetch instanceof Array ? selectWhenFetch : [
            selectWhenFetch
        ];
        this.options = data;
        this.reset(false);
        const firstPage = this._getPage(1).data;
        this.isDataFetched = true;
        if (selectWhenFetch) {
            this.selectedValues = this.filterValues(selectWhenFetch);
            this.renderOptions(firstPage, true, false);
            this._execCallbacks('change', this.selectedValues);
        } else if (render) {
            this.renderOptions(firstPage, true);
        }
        this._execCallbacks('fetch', data);
    },
    getOptions (cb) {
        const value = this.options;
        if (cb && typeof cb === 'function') return cb(value);
        return value;
    },
    fetch (customParams, selectWhenFetch = null) {
        if (selectWhenFetch && !selectWhenFetch.length) selectWhenFetch = null;
        if (this.fetchCached(selectWhenFetch)) return;
        customParams = customParams || this.$component.data('ajax-custom-params') || {};
        const params = _extends({
            per_page: this.perPage
        }, customParams);
        const fetchMethod = this.thor ? this.fetchThor(params) : this.fetchAjax(params);
        fetchMethod.done((data)=>this.onSuccess(data, selectWhenFetch)).catch((err)=>this.onFail(err, fetchMethod, selectWhenFetch));
    },
    onSuccess (data, selectWhenFetch) {
        if (this.collectionRoot) data = data[this.collectionRoot];
        data = typeof this.formatFunction === 'function' ? this.formatFunction(data) : data;
        if (this.enableCache) this.setCache(data);
        this.setOptions(data, selectWhenFetch);
    },
    onFail (err, fetchMethod, selectWhenFetch) {
        // Phoenix call
        if (this.attempts > 0) {
            setTimeout(()=>{
                fetchMethod.done((data)=>this.onSuccess(data, selectWhenFetch)).catch((err)=>this.onFail(err, fetchMethod, selectWhenFetch));
                this.attempts -= 1;
            }, 1000);
        } else {
            this.renderError('<div>Ops! Não foi possível obter os dados!</div>' + '<small>Se o erro persistir, entre em contato com o SAC.</small>');
            this.clearCache();
        }
    }
};
Fetch = Object.assign(Fetch, ajax, thor);
/* harmony default export */ const fetch = (Fetch);

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/difference.js
var difference = __webpack_require__(63259);
var difference_default = /*#__PURE__*/__webpack_require__.n(difference);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/find.js
var find = __webpack_require__(66051);
var find_default = /*#__PURE__*/__webpack_require__.n(find);
;// CONCATENATED MODULE: ./components/select/lib/pagination.js


/* harmony default export */ const pagination = ({
    _getOptions () {
        return this.isSearch ? this.filteredOptions : this.options;
    },
    _getPage (page) {
        const options = this._getOptions();
        const totalPages = Math.ceil(options.length / this.perPage);
        const from = (page ? page - 1 : 0) * this.perPage;
        const to = page * this.perPage;
        const res = {
            page: page,
            perPage: this.perPage,
            total: options.length,
            totalPages: totalPages,
            data: options.slice(from, to)
        };
        this.hasNextPage = page < totalPages;
        this.currentPage = page;
        return res;
    },
    _getNextPage () {
        if (!this.hasNextPage) {
            return null;
        }
        this.currentPage++;
        return this._getPage(this.currentPage);
    },
    _ensureHiddenOptions (data) {
        const $list = window.jQuery('.q-hidden-inputs', this.$component);
        const selectedOptions = this.selectedValues.map((value)=>{
            return find_default()(this.options, (opt)=>{
                const val = opt[this.valueField] || opt.toString();
                return val.toString() === value.toString();
            });
        }).filter((value)=>value);
        const hiddenOptions = difference_default()(selectedOptions, this.renderedValues);
        if (!data.length || !hiddenOptions.length) {
            $list.html('');
            return;
        }
        const html = hiddenOptions.map((opt)=>{
            const value = (opt[this.valueField] || opt.toString).toString().trim();
            const text = (opt[this.textField] || opt).toString().trim();
            return `
        <input type="${this.multiple ? 'checkbox' : 'radio'}"
          name="${this.name}${this.multiple ? '[]' : ''}"
          value="${value}"
          data-summary-label="${this.placeholder}"
          data-summary-display="${text.trim()}"
          checked>`;
        });
        $list.html(hiddenOptions.length ? html : '');
    }
});

;// CONCATENATED MODULE: ./components/select/lib/render.js
/* harmony default export */ const render = ({
    renderOption (data) {
        const value = data[this.valueField] || data.toString();
        const text = data[this.textField] || data.toString();
        const isChecked = this.selectedValues.indexOf(value.toString()) > -1;
        const html = `<li tabindex="0">
              <label class="${this.multiple ? 'checkbox' : 'radio'}">
                <input type="${this.multiple ? 'checkbox' : 'radio'}"
                       name="${this.name}${this.multiple ? '[]' : ''}"
                       value="${value}"
                       data-summary-label="${this.placeholder}"
                       data-summary-display="${text}"
                       ${isChecked ? 'checked' : ''}>
                <span>${text}</span>
              </label>
            </li>`;
        if (this.optionRenderingFunction) {
            return this.optionRenderingFunction({
                value,
                text,
                isChecked,
                option: data,
                name: this.name,
                placeholder: this.placeholder,
                multiple: this.multiple,
                defaultHtml: html
            });
        }
        return html;
    },
    renderOptions (data, replace = false, trigger = true) {
        if (!this.ajax) return;
        const $list = window.jQuery('.q-options', this.$component);
        if (this.isDataFetched && !data.length) {
            $list.html(`<div class="q-empty">${this.blankMessage || "Nenhum resultado"}</div>`);
            if (this.multiple) this.updateCounter();
            else this.updateSelected();
            return;
        } else if (!this.isDataFetched && !data.length) {
            return;
        }
        const options = data.map((option)=>this.renderOption(option));
        if (replace) $list.html(options);
        else $list.append(options);
        this.renderedValues = this.renderedValues.concat(data);
        this._ensureHiddenOptions(data);
        const $inputs = window.jQuery('input[checked]', this.$component);
        $inputs.prop('checked', true);
        if (trigger) $inputs.trigger('change');
        if (this.multiple) this.updateCounter();
        else this.updateSelected();
        this._execCallbacks('render', this.$component.get(0));
    },
    renderError (errorMessage) {
        const $list = window.jQuery('.q-options', this.$component);
        $list.html(`<div class="q-empty q-error">${errorMessage}</div>`);
    },
    updateCounter (count) {
        const $count = this.$component.find('.dropdown-toggle .q-count');
        count = count || this.selectedValues.length;
        if (count > 0) $count.html(`${count} selecionado${count > 1 ? 's' : ''}`);
        else if (count === 0) $count.html('');
    },
    getSelectedCount () {
        let count = this.selectedValues.length;
        if (!this.ajax) count = window.jQuery('input:checked', this.$component).length;
        return count;
    },
    unselectAll () {
        window.jQuery('.selected', this.$component).removeClass('selected');
    },
    select ($option) {
        if (this.getSelectedCount > this.options.limit) return;
        const $input = $option.find('input');
        const $placeholder = window.jQuery('.dropdown-toggle .q-placeholder', this.$component);
        const isChecked = $input.is(':checked');
        const selectedText = $input.data('summary-display') || $input.next('span').html() || $input.val();
        const hasPlaceholder = !this.hidePlaceholderWhenSelect && !!this.placeholder && this.placeholder.length;
        const hasSelectedText = !!selectedText && selectedText.length;
        let display = '';
        if (hasPlaceholder) display += this.placeholder.trim();
        if (hasPlaceholder && hasSelectedText) display += ': ';
        if (hasSelectedText) display += selectedText.trim();
        this.unselectAll();
        if (isChecked) {
            $option.addClass('selected');
            $placeholder.html(display);
            this.$component.attr('title', display);
        } else {
            $placeholder.html(this.placeholder);
            this.$component.attr('title', '');
        }
        this.close();
    },
    updateSelected () {
        const $placeholder = window.jQuery('.dropdown-toggle .q-placeholder', this.$component);
        const $input = window.jQuery('input:checked', this.$component);
        const value = $input.val();
        const option = this.options.find((o)=>o[this.config.valueField] === value);
        const optionDisplay = option ? option[this.config.textField] : null;
        if ($input.length) {
            const display = `${this.placeholder ? this.placeholder + ': ' : ''}
      ${$input.data('summary-display') || optionDisplay || value}`;
            $input.parents('li').addClass('selected');
            $placeholder.html(display);
            this.$component.attr('title', display);
        } else this.unselectAll();
    }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(34977);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./components/select/lib/search.js


/* harmony default export */ const search = ({
    bindSearch () {
        this.search = debounce_default()(this._search.bind(this), 250);
    },
    _staticSearch (text) {
        const $labels = window.jQuery('.dropdown-menu li label', this.$component);
        if (text.length) {
            $labels.each((i, el)=>{
                const $label = window.jQuery(el);
                const $parent = $label.parent('li');
                const labelText = this.removeAccents($label.text().toLowerCase());
                if (labelText.indexOf(text) > -1) {
                    $parent.show();
                } else {
                    $parent.hide();
                }
            });
        } else {
            window.jQuery('.dropdown-menu li', this.$component).show();
        }
    },
    _arraySearch (text) {
        text = text.trim();
        const options = this.options;
        this.renderedValues = [];
        this.isSearch = true;
        this.currentPage = 1;
        if (text.length) {
            this.filteredOptions = options.filter((option)=>{
                let optionText = option[this.textField] || option.toString();
                optionText = this.removeAccents(optionText.trim().toLowerCase());
                return optionText.indexOf(text) > -1;
            });
            this.renderOptions(this._getPage(1).data, true, false);
        } else {
            this.isSearch = false;
            const data = this._getPage(1).data;
            this.isSearch = true;
            if (difference_default()(data, this._getOptions()).length) {
                this.isSearch = false;
                this.renderOptions(data, true, false);
            }
        }
    },
    _search () {
        const text = this.removeAccents(window.jQuery('.q-search-input input', this.$component).val().toLowerCase());
        if (this.ajax) this._arraySearch(text);
        else this._staticSearch(text);
    },
    _bindSearchEvents () {
        if (!this.config.search) return;
        const self = this;
        const $input = window.jQuery('.q-search-input input', self.$component);
        $input.keydown(function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                return false;
            } else {
                self.search();
            }
        });
        window.jQuery('.q-search-input .q-clear-btn', this.$component).on('click', function() {
            $input.val('').trigger('change');
            self.search();
        });
    }
});

;// CONCATENATED MODULE: ./components/select/lib/utils.js
/* harmony default export */ const utils = ({
    removeAccents (text) {
        text = text.replace(/[àáâãÀÁÂÃ]/ig, 'a');
        text = text.replace(/[èéêÈÉÊ]/ig, 'e');
        text = text.replace(/[ìíÌÍ]/ig, 'i');
        text = text.replace(/[òóôÒÓÔ]/ig, 'o');
        text = text.replace(/[ùúüÙÚÜ]/ig, 'u');
        text = text.replace(/[çÇ]/ig, 'c');
        return text;
    },
    filterValues (values) {
        return values.filter((x)=>{
            const options = this.options.map((o)=>o[this.valueField] ? o[this.valueField].toString() : o.toString());
            return x && options.indexOf(x.toString()) > -1;
        });
    }
});

;// CONCATENATED MODULE: ./components/select/index.js
function select_extends() {
    select_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return select_extends.apply(this, arguments);
}



// Mixins







// TODO: Document qselect actions and events
class Select {
    _bindDropdownEvents() {
        const self = this;
        if (media_query/* MediaQuery.is */.z.is('xs')) {
            window.jQuery('.dropdown-menu', this.$component).addClass('dropdown-menu-keepopen');
        }
        window.jQuery('.dropdown-menu', this.$component).on('keydown', function(e) {
            if (self.isMobile) {
                return;
            }
            const $el = window.jQuery(this);
            const $focused = window.jQuery('li:focus', $el).not('.q-search-input');
            if (e.keyCode === 13) {
                const $input = window.jQuery('input', $focused);
                $input.prop('checked', !$input.is(':checked')).change();
                if (!self.multiple) {
                    self.select($focused);
                }
            }
        }).on('click', function(e) {
            self.multiple && self.$component.is('.open') && e.stopPropagation();
        }).on('click', '.js-close-select-dropdown-btn', function() {
            self.close();
        });
        this.$component.on('show.bs.dropdown', function() {
            if (media_query/* MediaQuery.is */.z.is('xs')) {
                window.jQuery('body').addClass('q-select-no-scroll');
            }
        }).on('hide.bs.dropdown', function() {
            if (media_query/* MediaQuery.is */.z.is('xs')) {
                window.jQuery('body').removeClass('q-select-no-scroll');
            }
        });
    }
    checkLimits(input) {
        const self = this;
        const $namePlaceholder = window.jQuery('.q-placeholder', self.$component).text().toLowerCase();
        const checkedCount = self.getSelectedCount();
        const index = self.selectedValues.indexOf(input.value);
        if (checkedCount > self.config.limit && self.config.limit > 0) {
            input.checked = false;
            self.selectedValues.splice(index, 1);
            self.updateCounter(self.config.limit);
            toastr.warning('Ops! Selecione até ' + self.config.limit + ' itens do filtro de ' + $namePlaceholder + '!');
        } else {
            self.updateCounter(checkedCount);
        }
    }
    _bindChangeEvents() {
        const self = this;
        window.jQuery(self.$component).on('change', 'input[type="checkbox"], input[type="radio"]', function(e) {
            self._execCallbacks('inputChange', e);
            const $parent = window.jQuery(this).parents('li');
            const $input = window.jQuery(this);
            const value = $input.val().toString();
            const i = self.selectedValues.indexOf(value);
            if (self.multiple) {
                if ($input.is(':checked') && i < 0) {
                    self.selectedValues.push(value);
                } else if (!$input.is(':checked') && i > -1) {
                    self.selectedValues.splice(i, 1);
                }
                self._execCallbacks('change', self.selectedValues);
            } else {
                if ($input.is(':checked')) {
                    self.config.value = value;
                    self._execCallbacks('change', value);
                }
            }
            if (self.multiple) {
                self.checkLimits(this);
            } else {
                if ($input.is(':checked')) {
                    self.select($parent);
                }
            }
        });
    }
    _bindKeyboardEvents() {
        const self = this;
        this.$component.on('keydown', function(e) {
            if (this.isMobile) {
                return;
            }
            const $focused = window.jQuery('li:visible:focus', self.$component).not('.q-search-input');
            if (e.keyCode === 38 || e.keyCode === 40) {
                e.preventDefault();
                if ($focused.length === 0) {
                    window.jQuery('li:visible', self.$component).not('.q-search-input').first().focus();
                } else if (e.keyCode === 40) {
                    $focused.nextAll('li:visible').not('.q-search-input').first().focus();
                } else if (e.keyCode === 38) {
                    const $prev = $focused.prevAll('li:visible').not('.q-search-input');
                    if ($prev.length) {
                        $focused.prevAll('li:visible').not('.q-search-input').first().focus();
                    } else {
                        if (self.isMobile) {
                            return;
                        }
                        self.$component.find('.q-search-input input').focus();
                    }
                }
            }
        }).on('show.bs.dropdown', function() {
            if (self.ajax && !self.isDataFetched) {
                self.fetch();
            }
            if (self.isMobile) {
                return;
            }
            setTimeout(()=>window.jQuery(this).find('.q-search-input input').focus(), 200);
        });
    }
    _bindScrollEvents() {
        const self = this;
        window.jQuery('.dropdown-menu .q-options', this.$component).on('scroll', function() {
            if (Math.ceil(window.jQuery(this).scrollTop() + window.jQuery(this).innerHeight()) >= window.jQuery(this)[0].scrollHeight - 1) {
                const nextPage = self._getNextPage();
                if (!nextPage) {
                    return;
                }
                const data = nextPage.data;
                self.renderOptions(data, false, false);
            }
        }).preventParentScroll();
    }
    mapRenderedOptions() {
        if (!this.config.textField || !this.config.valueField) {
            return;
        }
        this.selectedValues = [];
        const options = window.jQuery('.q-options input', this.$component).map((i, input)=>{
            const $input = window.jQuery(input);
            const ret = {};
            ret[this.config.textField] = $input.next('span').text();
            ret[this.config.valueField] = $input.val();
            if (this.multiple && input.checked) {
                this.selectedValues.push($input.val().toString());
            }
            return ret;
        }).toArray();
        this.options = options;
        if (this.multiple) {
            this.updateCounter();
        } else {
            this.updateSelected();
        }
    }
    loadConfig() {
        this.config = this.$component.data();
        this.enableCache = this.config.cache && !!window.sessionStorage && this.config.ajaxUrl;
        this.ajax = this.config.ajax;
        this.ajaxUrl = this.config.ajaxUrl;
        this.thor = this.config.thor;
        this.multiple = this.config.multiple;
        this.name = this.config.name;
        this.placeholder = this.config.placeholder;
        this.hidePlaceholderWhenSelect = this.config.hidePlaceholderWhenSelect;
        this.blankMessage = this.config.blankMessage;
        this.isMobile = media_query/* MediaQuery.is */.z.is('lt_md');
        this.configureCache();
        this.configureFetch();
    }
    static getValidActions() {
        return [
            'fetch',
            'close',
            'enable',
            'disable',
            'refresh',
            'reset',
            'getValue',
            'setValue',
            'getOptions',
            'setOptions',
            'getConfig',
            'setConfig',
            'setFormatFunction',
            'setOptionRenderingFunction',
            'clearCache',
            'on'
        ];
    }
    static handleActions($el, action, args) {
        if (!action) {
            return $el;
        }
        const validActions = Select.getValidActions();
        if (validActions.indexOf(action) < 0) {
            throw new Error(`"${action}" is not a valid action.`);
        }
        if (action.indexOf('get') > -1) {
            const el = $el.get(0);
            return el && $el.get(0).qselectInstance[action](...args);
        } else {
            $el.each((i, el)=>{
                el.qselectInstance[action](...args);
            });
            return $el;
        }
    }
    constructor(el){
        if (!el || el.qselectInstance) {
            return;
        }
        // General
        this.$component = window.jQuery(el);
        this.bindSearch();
        this.loadConfig();
        this.options = [];
        this.reset(false);
        // Handle selected for single input
        if (!this.multiple) {
            const $selected = window.jQuery('input:checked', this.$component);
            if ($selected.length) {
                this.select($selected.parents('li'));
            }
        }
        // Events
        this._bindDropdownEvents();
        this._bindChangeEvents();
        this._bindSearchEvents();
        this._bindKeyboardEvents();
        if (!this.ajax) {
            this.mapRenderedOptions();
            return;
        }
        // Ajax
        this._bindScrollEvents();
    }
}
const Modules = select_extends({}, cache, fetch, render, search, pagination, utils, externals);
Object.keys(Modules).forEach((key)=>{
    Select.prototype[key] = Modules[key];
});
(function($1) {
    'use strict';
    // Defining jQuery plugin
    if (!$1.fn.qselect) {
        $1.fn.qselect = function(action) {
            const $el = this;
            const args = $1.makeArray(arguments);
            args.shift();
            $el.each((i, el)=>!el.qselectInstance && (el.qselectInstance = new Select(el)));
            return Select.handleActions($el, action, args);
        };
    }
    // Applying to existing .q-select-input
    $1('.q-select-input').each((i, el)=>{
        $1(el).qselect();
    });
})(window.jQuery);


/***/ }),

/***/ 61258:
/***/ (() => {

(function($) {
    'use strict';
    if ($.fn.preventParentScroll) return;
    $.fn.preventParentScroll = function() {
        this.bind('mousewheel DOMMouseScroll', function(e) {
            const delta = e.originalEvent.wheelDelta || -e.originalEvent.detail;
            if (delta > 0 && $(this).scrollTop() <= 0) return false;
            return !(delta < 0 && Math.ceil($(this).scrollTop() + $(this).innerHeight()) >= $(this)[0].scrollHeight);
        });
    };
})(window.jQuery);


/***/ })

}]);